module.exports = __webpack_public_path__ + "img/icon-nav2_blue.d82294fd.svg";